import { FC } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { Box, Divider, HStack, Image, VStack } from '@chakra-ui/react';

import teapotImg from 'assets/brand/teapot.png';
import Button from 'components/_core/Button';
import Text from 'components/_core/Text';
import { navigateToBankTransfer } from 'features/Payments/Pages/Transfers/helpers';

import * as routes from '../../../../../routes';
import locales from './locales';

interface SecondaryBankAccountEmptyStateProps {
  bankAccountId: string | undefined;
}

export const SecondaryBankAccountEmptyState: FC<
  SecondaryBankAccountEmptyStateProps
> = ({ bankAccountId }) => {
  const history = useHistory();

  const handleCreditClick = () => {
    navigateToBankTransfer(history, {
      bankTransfer: {
        toBankAccountId: bankAccountId,
        transferType: 'internal',
      },
      variant: 'toAccount',
    });
  };

  return (
    <>
      <Divider />

      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        marginTop="space-32"
      >
        <VStack mt="space-64" paddingX="space-16">
          <Image height={90} src={teapotImg} width={90} />

          <Text
            color="light"
            mb="space-32"
            mt="space-16"
            size="sm"
            textAlign="center"
          >
            {locales.noTransaction}
          </Text>

          <HStack spacing="space-16">
            <Button
              as={Link}
              to={routes.getBankAccountDetailsPath(bankAccountId)}
              variant="secondary"
            >
              {locales.shareMyIban}
            </Button>
            <Button onClick={handleCreditClick} variant="primary">
              {locales.addFundsFromShineAccount}
            </Button>
          </HStack>
        </VStack>
      </Box>
    </>
  );
};
